const KEY = 'borelly:grid-columns';
class BGridDensity extends HTMLElement {
  connectedCallback() {
    this.grid = document.getElementById(this.dataset.target);
    let saved = null;
    try { saved = localStorage.getItem(KEY); } catch { /* storage no disponible */ }
    if (saved) this.apply(saved);
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-columns]');
      if (!btn) return;
      this.apply(btn.dataset.columns);
      try { localStorage.setItem(KEY, btn.dataset.columns); } catch { /* storage no disponible */ }
    });
  }

  apply(n) {
    if (this.grid) this.grid.dataset.columns = n;
    this.querySelectorAll('[data-columns]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.columns === n)));
  }
}
if (!customElements.get('b-grid-density')) customElements.define('b-grid-density', BGridDensity);
